import {
    AsNumber,
    IconDelete,
    Spacer
} from '@adserve/adserve-react-components';
import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';

const CopyTypeRow = ({
    copyType,
    backgroundColour,
    staticData,
    onRatioChange,
    onDelete,
    readOnly
}) => {
    const { formatNumber } = useContext(SystemSettingsContext);

    const scriptFactor = staticData?.scriptFactors.find(
        (x) => x.id === copyType?.scriptFactorId
    );

    const getSpotTypeName = (spotTypeId) => {
        return staticData.spotTypes.find((x) => x.id === spotTypeId)?.name;
    };

    const handleRatioChange = (event) => {
        if (!event.target.value) event.target.value = 0;

        if (onRatioChange) {
            const updatedCopyType = { ...copyType, ratio: event.target.value };
            onRatioChange(updatedCopyType);
        }
    };

    const firstPart = (sf) => {
        if (sf?.scriptLengthFirst) {
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right',
                            verticalAlign: 'middle'
                        }}
                    >
                        {sf.scriptLengthFirst}
                    </div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left',
                            verticalAlign: 'middle'
                        }}
                    >
                        {window.translate('First')}
                    </div>
                </>
            );
        }
        if (sf?.scriptLength) {
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right',
                            verticalAlign: 'middle'
                        }}
                    >
                        {sf.scriptLength}
                    </div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left'
                        }}
                    >
                        {window.translate('Any')}
                    </div>
                </>
            );
        }
        if (sf?.scriptLengthLast) {
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right'
                        }}
                    >
                        {sf.scriptLengthLast}
                    </div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left'
                        }}
                    >
                        {window.translate('Last')}
                    </div>
                </>
            );
        }

        return (
            <>
                <div
                    style={{
                        width: 'calc(50% - 15px)',
                        textAlign: 'right'
                    }}
                ></div>
                <div style={{ textAlign: 'center', width: 15 }}>-</div>
                <div
                    style={{
                        width: 'calc(50% - 15px)',
                        textAlign: 'left'
                    }}
                ></div>
            </>
        );
    };
    const secondPart = (sf) => {
        let partCount = 0;
        if (sf?.scriptLengthFirst) partCount++;
        if (sf?.scriptLength) partCount++;
        if (sf?.scriptLengthLast) partCount++;
        if (partCount < 2)
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right'
                        }}
                    ></div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left'
                        }}
                    ></div>
                </>
            );
        if (sf?.scriptLength) {
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right'
                        }}
                    >
                        {sf.scriptLength}
                    </div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left'
                        }}
                    >
                        {window.translate('Any')}
                    </div>
                </>
            );
        }
        if (sf?.scriptLengthLast) {
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right'
                        }}
                    >
                        {sf.scriptLengthLast}
                    </div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left'
                        }}
                    >
                        {window.translate('Last')}
                    </div>
                </>
            );
        }
    };
    const thirdPart = (sf) => {
        let partCount = 0;
        if (sf?.scriptLengthFirst) partCount++;
        if (sf?.scriptLength) partCount++;
        if (sf?.scriptLengthLast) partCount++;
        if (partCount < 3)
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right'
                        }}
                    ></div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left'
                        }}
                    ></div>
                </>
            );
        if (sf?.scriptLengthLast) {
            return (
                <>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'right'
                        }}
                    >
                        {sf.scriptLengthLast}
                    </div>
                    <div style={{ textAlign: 'center', width: 15 }}>-</div>
                    <div
                        style={{
                            width: 'calc(50% - 15px)',
                            textAlign: 'left'
                        }}
                    >
                        {window.translate('Last')}
                    </div>
                </>
            );
        }
    };

    return (
        <div style={{ display: 'flex', height: 40, width: '100%' }}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    boxSizing: 'border-box',
                    border: '1px solid #E3E3E3',
                    backgroundColor: backgroundColour
                }}
            >
                <IconDelete
                    style={{ width: 18, height: 18 }}
                    fill={!copyType?.id || readOnly ? '#CCCCCC' : '#414141'}
                    onClick={() => onDelete(copyType.id)}
                    disabled={!copyType?.id || readOnly}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    width: 230,
                    boxSizing: 'border-box',
                    border: '1px solid #E3E3E3',
                    backgroundColor: backgroundColour
                }}
            >
                {copyType?.spotTypeId
                    ? getSpotTypeName(copyType.spotTypeId)
                    : ''}
            </div>
            <Spacer width={29} />
            <div
                style={{
                    width: 295,
                    display: 'flex',
                    boxSizing: 'border-box',
                    border: '1px solid #E3E3E3',
                    backgroundColor: backgroundColour,
                    lineHeight: 2.4
                }}
            >
                {firstPart(scriptFactor)}
            </div>
            <Spacer width={30} />
            <div
                style={{
                    width: 295,
                    display: 'flex',
                    boxSizing: 'border-box',
                    border: '1px solid #E3E3E3',
                    backgroundColor: backgroundColour,
                    lineHeight: 2.4
                }}
            >
                {secondPart(scriptFactor)}
            </div>
            <Spacer width={30} />
            <div
                style={{
                    width: 295,
                    display: 'flex',
                    boxSizing: 'border-box',
                    border: '1px solid #E3E3E3',
                    backgroundColor: backgroundColour,
                    lineHeight: 2.4
                }}
            >
                {thirdPart(scriptFactor)}
            </div>
            <Spacer width={30} />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 107,
                    boxSizing: 'border-box',
                    border: '1px solid #E3E3E3',
                    backgroundColor: backgroundColour
                }}
            >
                <AsNumber
                    inputStyle={{ padding: 5, width: '60%' }}
                    formatNumber={formatNumber}
                    value={copyType?.ratio}
                    onChange={handleRatioChange}
                    allowFloat={true}
                    disabled={!copyType?.id || readOnly}
                />
            </div>
        </div>
    );
};

export default CopyTypeRow;
